<template>
    <div class="grid container">
      <div class="col-12">
        <div id="custom_card" class="card custom-card" v-if="Applicationsurvey">
          <div class="grid align-items-center">
            <!-- Left content (empty if not needed) -->
            <div class="col-12 md:col-4"></div>
  
            <!-- Centered title content -->
            <div class="col-12 md:col-4 text-center">
              <span class="title-text">महाराष्ट्र शासन</span><br>
              <span class="subtitle-text">मुख्यमंत्री सहाय्यता निधींसाठीचा अर्ज</span>
            </div>
  
            <!-- Right content with a simple table -->
            <div class="col-12 md:col-4">
              <table class="custom-table">
                <tr>
                  <td class="label">अर्ज क्र :</td>
                  <td class="input"></td>
                </tr>
                <tr>
                  <td class="label">दिनांक :</td>
                  <td class="input"></td>
                </tr>
              </table>
            </div>
          </div>
          

          <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">महत्वपूर्ण सूचना</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> १. डिस्चार्ज झालेल्या/उपचार पूर्ण झालेल्या खर्चाची प्रतिपूर्ती म्हणून अर्थसहाय्य दिले जाणार नाही याची नोंद घ्यावी.तसेच अर्ज करण्यापूर्वी खालील शासकीय योजनांसाठी पात्र असल्यास लाभ घ्यावा.</b><br/>
                २. रुग्ण महात्मा ज्योतीबा फुले जन आरोग्य योजना/आयुष्यामान भारत/राष्ट्रीय बालक स्वास्थ कार्यक्रम/धर्मदाय रुग्णालय इत्यादी कोणत्याही एका योजनेत लाभार्थी असल्यास अर्ज स्विकारण्यात येणार नाही.<br/>
                ३. अर्जात दर्शविलेल्या माहितीशी संबंधीत कागदपत्रे / प्रमाणपत्रे अर्जदाराने स्व साक्षांकित (Self-Attested) करुन सोबत जोडणे अनिवार्य आहे.<br/>
                <b>४. संशयास्पद अथवा खोटी/बनावट माहिती दिलेली आढळल्यास तो अर्ज रद्द करण्यात येईल तसेच कायदेशीर पोलीस कारवाई पात्र ठरेल.</b><br/>

                    </td>
                </tr>
            </table>

          </div>

          <div style="margin-top: 2%; text-align: center;">
            <table class="custom-table" style="width: 40%; margin: 0 auto; text-align: center;">
                <tr>
                <td class="header">अर्जदाराने भरावयाची माहीती</td>
                </tr>
            </table>
            </div>

            <div style="margin-top: 2%;">
                <span style="font-weight: 700; font-size: 1rem;">प्रति,</span><br/>
                <span style="font-weight: 700; font-size: 1rem;">मा. मुख्यमंत्री महोदय,</span><br/>
                <span style="font-weight: 700; font-size: 1rem;">महाराष्ट्र राज्य,</span><br/>
                <span style="font-weight: 700; font-size: 1rem;">मंत्रालय, मुंबई - ३२</span>

            </div>
            <div style="margin-top: 2%; text-align: center;">
                <span style="font-weight: 700; font-size: 1rem; text-align: center;">मी खात्रीपूर्वक लिहून देतो की,</span><br/>
                <span style="font-weight: 700; font-size: 1rem; text-align: center;"   >(खालील १ किंवा २ पैकी)</span>

            </div>
            <div style="margin-top: 2%;">
                <div class="col-12">
                    <span > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;१) &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; श्री/श्रीमती/सौी/कुमारी / कुमार <b> {{ Applicationsurvey.patient_name_marathi }} </b> हे दिनांक  <b>{{ Applicationsurvey.admission_date }} </b> </span>
                    
                    <span> पासून (रुग्णालयाचे नाव) <b> {{Applicationsurvey.hospital_name}} </b> या रुग्णालयात दाखल</span>
                    
                    <span>आहेत व त्यांना आज दिनांक <b> {{ Applicationsurvey.estimation_date }} </b> रोजी पर्यंत रुग्णालयातून डिसचार्ज मिळालेला नाही.</span>
                    </div>

            </div>

            <div style="margin-top: 2%;text-align: center;">
                <span style="font-weight: 700; font-size: 1rem; text-align: center;" >किंवा</span>
            </div>

            <div style="margin-top: 2%;">
                  <div class="col-12">        
                <span > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;२) &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; श्री/श्रीमती/सौी/कुमारी / कुमार  <b>{{ Applicationsurvey.patient_name_marathi }} </b> यांना अद्यापही आज</span>
               
                
                <span>दिनांक <b>{{ Applicationsurvey.admission_date }} </b> पर्यंत रुग्णालयात दाखल केलेले नाही. त्यांना दिनांक <b>{{ Applicationsurvey.admission_date }} </b> पर्यंत रुग्णालयात दाखल</span>
                
                <span>करण्यात येणार आहे.</span>
                </div>
            </div>

            <div style="margin-top: 2%; text-align: right;margin-right: 10%;">
                <span style="font-weight: 700; font-size: 1rem; margin-right: 5%;">सही/-</span><br />
                <span style="font-weight: 700; font-size: 1rem;">&nbsp;&nbsp;&nbsp;&nbsp;(लिहून देणाऱ्याची)</span>
            </div>
            <hr style="margin-top: 2%; border: none; border-top: 2px dashed black;" />

            <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">रुग्णांसाठी अर्ज करणाऱ्या व्यक्तीचा तपशील</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> १. अर्जदारांचे संपूर्ण नाव व आधारकार्ड क्रमांक: {{ Applicationsurvey.applicant_name }}</b><br/>
                        <div style="display: flex; justify-content: flex-end;">
                          <div v-for="(digit, index) in applicantUidDigits" :key="index">
                            <input
                              v-model="applicantUidDigits[index]"
                              type="text"
                              maxlength="1"
                              class="digit-box"
                            />
                          </div>
                        </div><br>
                            <b> २. अर्जदाराचा कायमचा पत्ता : {{ Applicationsurvey.permenant_address_applicant }} </b>
                            <b></b><br/>
                            <b>तालुका :. {{Applicationsurvey.applicant_taluka}} जिल्हा :. {{Applicationsurvey.applicant_district}} पिन:.{{ Applicationsurvey.applicant_pin }}</b><br/>
                            <b>३. अर्जदाराचा मोबाईल क्रमांक व रुग्णाशी असलेल नाते : ({{Applicationsurvey.applicant_mobile }}) {{ Applicationsurvey.applicant_patient_relation }}  </b>


                    </td>
                </tr>
            </table>

          </div>

          <div class="grid align-items-center" style="margin-top: 2%;">
            <!-- Left content (empty if not needed) -->
            <div class="col-12 md:col-4"></div>
  
            <!-- Centered title content -->
            <div class="col-12 md:col-4 text-center">
              <span class="title-text">महाराष्ट्र शासन</span><br>
              <span class="subtitle-text">मुख्यमंत्री सहाय्यता निधींसाठीचा अर्ज</span>
            </div>
  
           
          </div>

          <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">रुग्णाचा तपशील</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> १. रुग्णाचे संपूर्ण नाव (मराठीत) :. {{ Applicationsurvey.patient_name_marathi }}</b><br/>
                    <b>  (In Capital Letters) इंग्रजीत  :. {{ Applicationsurvey.patient_name_english }}</b><br/>
                    <b> २. रुग्णाचा आधार कार्डे क्रमांक  :. {{ Applicationsurvey.patient_uid }}</b><br/>
                    <b>३. रुग्णाचा कायमचा पत्ता :. {{ Applicationsurvey.patient_permanent_address }}</b><br/>
                    <b> ४. रुग्णांच्या जवळच्या नातेवाईकांचा चालू मोबाईल नं. :. {{ Applicationsurvey.patient_relative_mobile }}</b><br/>
                    <b> ५. रुग्णाचा ई मेल  :. {{ Applicationsurvey.patient_email_id }}</b><br/>

                    </td>
                </tr>
            </table>

          </div>

          <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">आजाराबाबत तपशील</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> १. रुग्णाला झालेल्या आजाराचे नाव  :. {{ Applicationsurvey.disease }}</b><br/>
        <b>  २. उपचार चालू असलेल्या रुग्णालयाचे नाव व पत्ता : :. {{ Applicationsurvey.hospital_name }} , {{ Applicationsurvey.hospital_address }}</b>
        <b></b><br/>
        <b>तालुका :. {{ Applicationsurvey.hospital_taluka }}  जिल्हा :. {{ Applicationsurvey.hospital_district  }}  पिन:. {{  Applicationsurvey.hospital_pin}}</b><br/>
        <b> ३. उपचारासाठी रुग्णालयाच्या खर्चाचे अंदाजपत्रक रु. : {{Applicationsurvey.estimated_expenses}} /- दिनाक :.{{ Applicationsurvey.estimation_date }} (सोबत जोडणे)
</b><br/>
        <b>४. संपूर्ण उपचारासाठी लागणारा अंदाजे कालावधी  :.{{ Applicationsurvey.estimated_time }}</b><br/>
        <b>५. उपचार चालू असलेल्या रुग्णालयाचा संपर्क क्रमांक : :. {{ Applicationsurvey.hospital_contact_no }}</b><br/>
        <b> ६. उपचार करत असलेल्या डॉक्टरांचे नाव   :. {{ Applicationsurvey.doctor_name }}</b><br/>
        <b> ७. रुग्ण रुग्णालयात दाखल असल्यास बेड व वार्ड क्रमांक.  :.{{ Applicationsurvey.bed_ward_num }} आणि दाखल झाल्याची
            दिनांक:. {{ Applicationsurvey.estimation_date }}</b><br/>
        <b>८. रुग्णालयाचा ई मेल आयडी :.{{ Applicationsurvey.hospital_email }}</b><br/>


                    </td>
                </tr>
            </table>

          </div>

          <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">आवश्यक कागदपत्रांचा तपशील</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> १. कुटुंबाचे एकत्रित उत्पन्न रुपये:. {{Applicationsurvey.family_income}} उत्पन्नाचे प्रमाणपत्र क्रमांक व दिनांक {{ Applicationsurvey.income_certificate_num }} , {{ Applicationsurvey.income_certificate_date }}</b><br/>
                        <b>(पतीचे/पत्नीचे उत्पन्न प्रमाणपत्र जोडावे) (रुग्ण अल्पवयीन असल्यास वडीलांचे / आईचे)</b><br/>
                        
                        <b>२. शिधापत्रिका क्रमांक :. {{Applicationsurvey.ration_Card_num}} दिनांक :. {{ Applicationsurvey.ration_card_date }} </b><br/>
                        <b>(रुग्णाचे शिधापत्रिकेत नाव असणे आवश्यक)</b><br/>


                    </td>
                </tr>
            </table>

          </div>

          <div style="margin-top: 2%;">
            <table class="custom-table">
                <tr>
                    <td class="header">आर्थिक मदतीसाठी शिफारस करणाऱ्या लोकप्रतिनिधी (मा. मंत्री / मा. आमदार / मा. खासदार) यांचा तपशिल (असल्यास)</td>
                </tr>
                <tr>
                    <td style="padding: 2%;">
                        <b> संपूर्ण नाव व पदनाम :. {{ Applicationsurvey.leader_name }} , {{ Applicationsurvey.leader_post }}</b><br/>

                    </td>
                </tr>
            </table>

          </div>

          <div style="margin-top: 2%;">
            <div class="col-12">
                <span > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; मी प्रमाणित करतो/करते की वरील प्रमाणे दर्शविलेली सर्व माहिती खरी व सत्य आहे. त्यात काही खोटी माहिती आढळल्यास शासनाच्या नियमाप्रमाणे होणाऱ्या कायदेशीर कार्यवाईस मी सही करणारा जबाबदार राहील याची मला जाणीव आहे.
                </span>
            </div>

          </div>

          <div style="margin-top: 2%;">
            <div class="grid align-items-center">
            <!-- Left content (empty if not needed) -->
            <div class="col-12 md:col-4">
                <span style="font-weight: 700; font-size: 1rem;">रुग्णाचा फोटो</span><br/>
                <img :src="patientPhoto" alt="patient photo" style="width: 30%; height: 30%; margin-top: 2%;"/>
            </div>
  
            <!-- Centered title content -->
            <div class="col-12 md:col-4">
                <span style="font-weight: 700; font-size: 1rem;">अर्जदाराचा फोटो</span><br/>
                <img :src="applicantPhoto" alt="applicant photo" style="width: 30%; height: 30%; margin-top: 2%;"/>

            </div>
  
            <!-- Right content with a simple table -->
            <div class="col-12 md:col-4">
                <span style="font-weight: 700; font-size: 1rem;">अर्जदाराची सही / अंगठा :-</span>
            </div>
          </div>
          </div>


          

        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        ApplicationDetails: null, // Initialize ApplicationDetails
        Applicationsurvey: [], // Initialize Applicationsurvey as an array
        applicantUidDigits: [],
        patientPhoto:'',
        applicantPhoto:'',
      };
    },
    async mounted() {
      if (localStorage.getItem("applicationdata")) {
        this.ApplicationDetails = await JSON.parse(localStorage.getItem("applicationdata"));

        if (localStorage.getItem("surveydata")) {
          const survey = JSON.parse(localStorage.getItem("surveydata"));
          this.Applicationsurvey = JSON.parse(survey); // Directly assign the parsed survey to Applicationsurvey
          this.applicantUidDigits = this.Applicationsurvey.applicant_uid.split('');
          this.patientPhoto = this.Applicationsurvey.patient_photo[0].content;
          this.applicantPhoto = this.Applicationsurvey.applicant_photo[0].content;
        }

        // Clear the data from localStorage after usage
        // localStorage.setItem("applicationdata", "");
        // localStorage.setItem("surveydata", "");
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error!!!",
          detail: "Data Not Found",
          life: 3000,
        });

        this.$router.push({ name: "ApplicationList" });
        return false;
      }
    }
  };
</script>

  
  <style scoped>
  .custom-card {
    border: 2px solid black; 
    border-radius: 8px; 
    padding: 80px; 
  }
  
  .container {
    margin-bottom: 20px;
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 20px;
  }
  /* Media query for mobile view */
@media screen and (max-width: 767px) {
  .custom-card {
    padding: 0; /* Remove padding on small screens */
  }

  .container {
    margin: 0; /* Remove margin on small screens */
  }
}
  .header{
    text-align: center;
    font-weight: 700;
    font-size: 1rem;
  }
  
  .title-text {
    font-weight: 800;
    font-size: 2rem;
  }
  
  .subtitle-text {
    font-weight: 600;
    font-size: 1.5rem;
  }
  
  .custom-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .custom-table td {
    border: 1px solid black;
    padding: 10px;
  }
  
  .label {
    font-weight: 600;
    text-align: left;
    width: 50%;
  }
  
  .input {
    width: 50%;
    height: 30px;
  }
  .digit-box{
    width: 25px; 
    height: 25px;
     font-size: 1.2rem; 
     border: 1px solid black; 
     border-radius: 1px;
  }
  </style>
  